module.exports = __webpack_public_path__ + "media/images/logo/Logo-1b126f5d82913d3abaf266a09a228619.jpg";